import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent implements OnInit {

  search : string ;

  constructor() { }
  @Input() placeholder;
  @Output() searchChange = new EventEmitter();

  ngOnInit() {
  }

  sendData(value) {
    if (value.length === 0) {
    this.searchChange.emit(value);
  }
  }

  testEnter(val) {
    this.searchChange.emit(val);
  }

  testBack(val) {

    if (val.length === 0) {
      this.searchChange.emit(val);
    }
  }

}
